module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/top/banner01-f14b723529f5c86d15c07b9fa96ba9e8.png";